import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
function Breadcrumb() {
  return (
    <div className="breadcrumbStyle">
     <div className="container">
        <Link to="/">Trang chủ</Link>
      <span className="breadcrumbSeparator">
        <FontAwesomeIcon icon="angle-right" />
      </span>
      <span className="active">
        <Link to="/media">Thư viện</Link>
      </span>
     </div>
    </div>
  );
}
export default Breadcrumb;
